export const formatIndicatorName = (indicator) => {
	return `${indicator.Name}, ${indicator.Units}`;
};
